import { ICellRendererParams } from 'ag-grid-community';
// eslint-disable-next-line import/no-internal-modules
import { renderToStaticMarkup } from 'react-dom/server';
import { csatRender } from 'components/organisms/projects/project-list/columns/renderer';

export const CsatRatingRenderer = ({ value }: ICellRendererParams): string => {
  return renderToStaticMarkup(csatRender(value));
};
